import React from "react";

const Intro = () => {
  return (
    <>
      <div className="intro">
        <div className="description">
          <h2>Fire Movie</h2>
          <p>Unlimited movies, TV shows, and more Watch anywhere</p>
        </div>
      </div>
    </>
  );
};

export default Intro;
